export default __webpack_public_path__ + "static/media/79.5ae04978.jpeg";